import type {AppThunk} from '../../../actions/types'
import type {ProblemOccurrence} from '../../../services/rest'
import {restApi} from '../../../services/rest'
import type {ProjectId} from '../../../types'
import {stringifyId} from '../../../types'
import {BS} from '../../../types/BS_types'
import type {WritableKeyValue} from '../../../utils/object'

import {problemOccurrenceFields} from './BuildProblems.rest'

const getFetchProblemOccurenceArg = (problemLocator: string) => ({
  problemLocator,
  fields: problemOccurrenceFields,
})

export const fetchProblemOccurrence = (problemLocator: string) =>
  restApi.endpoints.getBuildProblemOccurrence.initiate(
    getFetchProblemOccurenceArg(problemLocator),
    {subscribe: false, forceRefetch: true},
  )

export const assignProblemsInvestigations =
  (
    projectId: ProjectId,
    problemOccurrences: ReadonlyArray<ProblemOccurrence>,
    fixMode = false,
    submitHandler?: () => unknown,
  ): AppThunk<any> =>
  () => {
    const problemsData: WritableKeyValue<string, string> = {}
    problemOccurrences.forEach(problemOccurrence => {
      const problemId = problemOccurrence?.problem?.id
      const buildId = problemOccurrence?.build?.id
      if (problemId != null && buildId != null) {
        problemsData[`BuiPro${stringifyId(problemId)}`] = `${stringifyId(buildId)}`
      }
    })
    BS?.BulkInvestigateMuteTestDialog?.showForBuildProblems(
      problemsData,
      fixMode,
      true,
      submitHandler,
    )
  }
